// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import React from 'react';
import { QCResult } from 'components/project/data/filter/filters-defaults';
import IconThumbsDownRed from 'components/treactui-template/icons/IconThumbsDownRed';
import IconThumbsUpGreen from 'components/treactui-template/icons/IconThumbsUpGreen';
import IconUndefined from 'components/treactui-template/icons/IconUndefined';

interface Props {
  processTag: QCResult;
  size: string;
}

export default function ProcessTag({ processTag, size }: Readonly<Props>) {
  switch (processTag) {
    case QCResult.Bad:
      return <IconThumbsDownRed width={size} height={size} />;
    case QCResult.Good:
      return <IconThumbsUpGreen width={size} height={size} />;
    case QCResult.Undefined:
      return <IconUndefined width={size} height={size} />;
    default:
      return <div style={{ width: size, height: size }} />;
  }
}
